module.exports = __webpack_public_path__ + "img/106.081b9e20.jpg";